import debugLogger from './debug.js';

// Idle timeout utility
class IdleTimeout {
  constructor(timeoutMs = 21600000, onTimeout) { // Default 6 hours
    this.timeoutMs = timeoutMs;
    this.onTimeout = onTimeout;
    this.timeoutId = null;
    this.isActive = false;
    
    // Events that indicate user activity
    this.activityEvents = [
      'mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'
    ];
    
    this.resetTimeout = this.resetTimeout.bind(this);
  }

  start() {
    if (this.isActive) return;
    
    this.isActive = true;
    this.resetTimeout();
    
    // Add event listeners for user activity
    this.activityEvents.forEach(event => {
      document.addEventListener(event, this.resetTimeout, true);
    });
    
    // Only log when starting, not on every reset
    debugLogger.log('IdleTimeout: Started monitoring user activity (6 hours timeout)');
  }

  stop() {
    if (!this.isActive) return;
    
    this.isActive = false;
    
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    
    // Remove event listeners
    this.activityEvents.forEach(event => {
      document.removeEventListener(event, this.resetTimeout, true);
    });
    
    // Only log when stopping, not on every reset
    debugLogger.log('IdleTimeout: Stopped monitoring user activity');
  }

  resetTimeout() {
    if (!this.isActive) return;
    
    // Clear existing timeout
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    
    // Set new timeout (silent reset - no console logging)
    this.timeoutId = setTimeout(() => {
      debugLogger.log('IdleTimeout: User inactive for 6 hours, logging out');
      this.onTimeout();
    }, this.timeoutMs);
  }

  // Method to manually reset timeout (useful for API calls)
  reset() {
    this.resetTimeout();
  }

  // Method to update timeout duration
  setTimeout(timeoutMs) {
    this.timeoutMs = timeoutMs;
    if (this.isActive) {
      this.resetTimeout();
    }
  }
}

export default IdleTimeout;



